"use client";

import { useEffect } from "react";

/**
 * Fetches /api/auth/member-token to set the member_token cookie for cross-domain auth.
 * Must run in a client component because cookies can only be modified in Route Handlers
 * or Server Actions-not in Server Components like the root layout.
 */
export function MemberTokenRefresher({ enabled }) {
  useEffect(() => {
    if (!enabled) return;
    fetch("/api/auth/member-token", { credentials: "include" }).catch(() => {
      // Silently ignore-user may be logged out or Convex unreachable
    });
  }, [enabled]);

  return null;
}
